import React, { useEffect, useState } from "react";
import {
  useSearchParams
} from "react-router-dom";
import { Link } from "react-router-dom";
import s from './books.module.css';
import {getData, postData, postFormData} from '../middleware/apiMiddleware';
import Book from '../components/Book';
import CreateBook from '../components/CreateBook';
import CreateCard from '../components/CreateCard';
import { useNavigate } from "react-router-dom";
import Select from 'react-select';
import {Form, InputGroup} from 'react-bootstrap';
import { ReactComponent as SearchSolid} from '../asset/search-solid.svg';
import addPng from'../asset/add.png';
import searchPng from'../asset/search.png';
import starPng from'../asset/star.png';
import starDarkPng from'../asset/star-dark.png';
import babyPng from'../asset/baby.png';
import communicationPng from'../asset/communication.png';
import poemPng from'../asset/poetry.png';
import cardGamesPng from'../asset/card-games.png';
import {RedButton, GreenButton, BlueButton} from '../components/MyButton';
import {Image} from 'react-bootstrap';
import {setGeneralStorage, getGeneralStorage} from '../middleware/dataStorage';
import {ItemTypeIcon, ItemConstant} from '../middleware/MyConstant';


import examPng from'../asset/exam.png';



export default function Books() {
	const navigate = useNavigate();
	let [searchParams, setSearchParams] = useSearchParams();
	let defaultToggle = getGeneralStorage('bookPanelToggle') ?? "ALL";
	
	const [toggleCreate, setToggleCreate] = useState(false);
	
	const [searchInputs, setSearchInputs] = useState({
		'tag' : defaultToggle,
		'page' : "1",
		'limit' : "20",
		'searchId' : "",
		'searchName' : "",
	});
	
	const [generalData, setGeneralData] = useState({
		items:[],
		itemTag:[{value:'ALL', label : 'ALL'}],
	});
	
	const [pageData, setPageData] = useState({
		'maxPage':0,
		'pageOptions':[],
	});
	
	const generalItemUpload = async (itemId, selectedFile) => {

		try {
			const data = new FormData();
			data.append("itemId", itemId);
			data.append("generalfile", selectedFile);
			
      let res = await postFormData("utility/generalItemUpload", data, navigate);
			return res.data;
    } catch (err) {
			return null;
      console.log(err);
    }
	}
	
	const fetchData = (myParam) => {	
		getData('bookApi/listBookItems?' + (new URLSearchParams(myParam)).toString(), navigate)
			.then(res => {
				const itemTag = res.metadata.itemTag;
				let maxPage =	res.metadata.maxPage;
				
				const po = [];
				for (let i = 1; i <= maxPage; i++) { po.push(i); }
				
				setPageData ({
					'maxPage':maxPage,
					'pageOptions':po,
				})
				return setGeneralData({ items: res.data, itemTag: itemTag })
			}
		);
	}
	
	const fetchFromParam = () => {
		let tag = searchParams.get("tag") || searchInputs.tag;
		let page = searchParams.get("page") || searchInputs.page;
		let limit = searchParams.get("limit") || searchInputs.limit;
		let searchId = searchParams.get("id") || searchInputs.searchId;
		let searchName = searchParams.get("name") || searchInputs.searchName;
		
		let myParam = {tag, page, limit};
		
		if (searchId.trim() !== "") {
			myParam['id'] = searchId;
		}
		if (searchName.trim() !== "") {
			myParam['name'] = searchName;
		}
		
		setSearchParams(myParam); 
		
		fetchData(myParam);	
	}
	
	useEffect(() => {
		fetchFromParam();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	
	const changeType = () => {
			setSearchParams(searchInputs);
			fetchData(searchInputs);	
	}
	
	const loadTag = (tag) => {
		
		setGeneralStorage('bookPanelToggle', tag);
		
		let tmpSearchInputs = {...searchInputs, ['tag']:tag};
		setSearchInputs(tmpSearchInputs);
		
		setSearchParams(tmpSearchInputs);
		fetchData(tmpSearchInputs);	
	}
	
	const searchById = () => {		
		let tmp = {}
		if (searchInputs.searchId.trim() !== "") {
			tmp = {...searchInputs, ['searchName']:''}
		} else {
			tmp = {...searchInputs, ['searchId']:'',['searchName']:''}
		}
		
		setSearchInputs(tmp);
		setSearchParams(tmp);
		fetchData(tmp);	
	}
	
	const searchByName = () => {		
		let tmp = {}
		if (searchInputs.searchName.trim() !== "") {
			tmp = {...searchInputs, ['searchId']:''}
		} else {
			tmp = {...searchInputs, ['searchId']:'',['searchName']:''}
		}
		setSearchInputs(tmp);
		setSearchParams(tmp);
		fetchData(tmp);	
	}
	
	const updatePage = (p) => {		
		let param = {...searchInputs, ["page"]:p};
		setSearchInputs(param);
		
		let {searchId, searchName, ...myParam} = param;
		
		if (searchInputs.searchId.trim() !== "") {
			myParam['id'] = searchId;
		}
		if (searchInputs.searchName.trim() !== "") {
			myParam['name'] = searchName;
		}
		setSearchParams(myParam); 
		fetchData(myParam);
	}
	
	const DivDifficulty = ({str}) => {
		switch(str) {
			case "Pre-DSE":			
				return (<div style={{fontWeight:"italic", color:"#c46416", margin:"auto", textAlign:"center", textDecoration: "underline"}}>Pre-DSE</div>)
			case "Essential":
				return (<div style={{fontStyle:"bold", color:"#c46416",margin:"auto",  textAlign:"center"}}>E</div>)
			case "Intermediate+":
				return (<div style={{fontWeight:"italic", color:"white", background:"#c46416", borderRadius:"5px", width:"40px", margin:"auto", textAlign:"center"}}>I+</div>)
				
			case "Advanced":
				return (<div style={{fontStyle:"bold", color:"white", background:"#c46416", borderRadius:"5px", width:"40px", margin:"auto", textAlign:"center"}}>A</div>)
				
				
		}
		return (<div style={{background:"black", color:"white"}}>X</div>)
	}
	

	
	
	const ItemTagIcon = ({itemTag, itemType}) => {
		if (ItemConstant.AllKeyItemIts.includes(itemType)) {
				return (
				<Image className={s.iconSmall} fluid
					src={examPng} rounded />	);
		}
		
		
		switch(itemTag) {
			case "phonics":
				return (
				<Image className={s.iconSmall} fluid
					src={communicationPng} rounded />	);
			case "baby":
				return (
				<Image className={s.iconSmall} fluid
					src={babyPng} rounded />	);
			case "poem":
				return (
				<Image className={s.iconSmall} fluid
					src={poemPng} rounded />	);
			default :
				return (
				<Image className={s.iconSmall} fluid
					src={babyPng} rounded />	);
		}
	}
	
	const publishItem = (itemId, indexD) => {
		
		
		let tmpItems = [...generalData.items];
		tmpItems[indexD].isPublished = !tmpItems[indexD].isPublished;
		
		
		let obj = {
			'itemId' : itemId,
			'isPublished' : tmpItems[indexD].isPublished,
		}
		postData("item/publish", obj, navigate); 
		
		
		
		setGeneralData({...generalData, ['items']:tmpItems});		
	}
	
	const linkItemWithImage = (itemId, path) => {
		let obj = {
			itemId, path
		}
		
		postData("item/linkItemWithImage", obj, navigate); 
	
	}
	
	
	
	const DataList = ({items}) => {
		
		return (<div>
				{
					items.map((d, indexD)=>(
							<div key={d.itemId}>
								<div className={s.itemsHolder}>
									<div className={s.iconHolder} onClick={()=>publishItem(d.itemId, indexD)}>
										{
											(d.isPublished == 0) && 	(<Image className={s.iconSmaller} fluid src={starDarkPng} rounded />	)
										}
										{
											(d.isPublished == 1) && 	(<Image className={s.iconSmall} fluid src={starPng} rounded />	)
										}
									</div>
									<div><ItemTypeIcon itemType={d.itemType}/></div>
									<div>{d.itemId}</div>
									<div className={s.itemName}>{d.name}</div>
									<div><ItemTagIcon itemTag={d.tags} itemType={d.itemType}/></div>
									{
										(d.itemType != 51) && (<div>
											<Link to={`/generalitem/${d.itemId}`} target="_blank" rel="noopener noreferrer" className="billBtn billBtn-default">
												edit
											</Link>
										</div>)
									}
									
									{
										<div style={{display:"flex"}}>
											<div style={{borderRight:"1px solid #22222222", padding:"0 10px", width:"80px", textAlign:"left"}}>
												{
													(d.code) ? (<div>{d.code}</div>) : (<div style={{color:"#e62e00"}}>X</div>)
												}
											</div>
											<div style={{borderRight:"1px solid #22222222", padding:"0 10px"}}>
												{
													(d.relationshipCode) ? (<div>{d.relationshipCode}</div>) : (<div style={{color:"#e62e00"}}>X</div>)
												}
											</div>
											<div style={{borderRight:"1px solid #22222222", padding:"0", width:"60px"}}>
												{
													(d.difficulty) ? (<DivDifficulty str={d.difficulty} />) : (<div style={{color:"#e62e00"}}>X</div>)
												}
											</div>
											<div style={{padding:"0 10px", textAlign:"left"}}>
												{
													(d.textType) ? (<div>{d.textType}</div>) : (<div style={{color:"#e62e00"}}>X</div>)
												}
											</div>
										</div>
									}
									
								</div>
								{(d.isShow) && (<Book itemId={d.itemId} />)}
							</div>
						)
					)
				}
			
			
				
			</div>)
	}
	
	return (
		<div>
			<div className={s.inputHolder}>
			
			
			{(!toggleCreate) && (<>
				<div className={s.itemIdInput}>
					<InputGroup>
						<div className="billBtn billBtn-default search-icon" onClick={searchById}>
							<SearchSolid className="search-icon-svg"/>
						</div>
						<Form.Control value={searchInputs.searchId}
							onChange={e => setSearchInputs({...searchInputs, ['searchId']:e.target.value})} 
							placeholder="Search by id"
							aria-label="Search by id"
							aria-describedby="basic-addon1"
						/>
					</InputGroup>
				</div>
				<div className={s.itemIdInput}>
					<InputGroup>
						<div className="billBtn billBtn-default search-icon" onClick={searchByName}>
							<SearchSolid className="search-icon-svg"/>
						</div>
						<Form.Control value={searchInputs.searchName}
							onChange={e => setSearchInputs({...searchInputs, ['searchName']:e.target.value})} 
							placeholder="Search by name"
							aria-label="Search by name"
							aria-describedby="basic-addon1"
						/>
					</InputGroup>
				</div>
				
			</>)
			}
				
				<div>
				
					<label htmlFor="imgs-upload" className={s.custom_file_upload} style={{margin:"5px"}}>
						<input id="imgs-upload" type="file" style={{display:"none"}} multiple onChange={
							async (e) => {
								for(let f of e.target.files) {
									
									
									
									
									let itemId = f.name.substring(0, f.name.lastIndexOf('.'))
									if (!isNaN(+itemId)) {
										let path = await generalItemUpload(itemId, f);
								
										if (path) {
											linkItemWithImage(itemId, path);
										}
									}
									
								}
								
								/**/
							}} />
						Upload Image
					</label>
				</div>
				
				
				<div className={s.inputHolderEmpty}>
					<div>
						<div className={s.inputHolderEmptySub}>
							<img onClick={()=>setToggleCreate(!toggleCreate)} className={s.icon} src={(!toggleCreate) ? addPng : searchPng} alt="icon"/>
						</div>
					</div>
				</div>
				
				
			</div>
			
			{(!toggleCreate) && (<>
			<div>
				<div style={{textAlign:"left", display:"flex"}}>
					<div style={{margin:"5px"}}>
						<GreenButton isEnabled={(searchInputs.tag=="ALL") ? false:true} clickedAction={()=>{loadTag("ALL")}} bText={"ALL"} />
					</div>
					<div style={{margin:"5px"}}>
						<BlueButton isEnabled={(searchInputs.tag=="key-reading") ? false:true} clickedAction={()=>{loadTag("key-reading")}} bText={"key-reading"} />
					</div>
					<div style={{margin:"5px"}}>
						<BlueButton isEnabled={(searchInputs.tag=="key-speaking") ? false:true} clickedAction={()=>{loadTag("key-speaking")}} bText={"key-speaking"} />
					</div>
					<div style={{margin:"5px"}}>
						<BlueButton isEnabled={(searchInputs.tag=="key-writing") ? false:true} clickedAction={()=>{loadTag("key-writing")}} bText={"key-writing"} />
					</div>
					<div style={{margin:"5px"}}>
						<BlueButton isEnabled={(searchInputs.tag=="key-listening") ? false:true} clickedAction={()=>{loadTag("key-listening")}} bText={"key-listening"} />
					</div>
					<div style={{margin:"5px"}}>
						<BlueButton isEnabled={(searchInputs.tag=="key-podcast") ? false:true} clickedAction={()=>{loadTag("key-podcast")}} bText={"key-podcast"} />
					</div>
					<div style={{margin:"5px"}}>
						<GreenButton isEnabled={(searchInputs.tag=="baby") ? false:true} clickedAction={()=>{loadTag("baby")}} bText={"baby"} />
					</div>
					<div style={{margin:"5px"}}>
						<GreenButton isEnabled={(searchInputs.tag=="phonics") ? false:true} clickedAction={()=>{loadTag("phonics")}} bText={"phonics"} />
					</div>
					<div style={{margin:"5px"}}>
						<GreenButton isEnabled={(searchInputs.tag=="poem") ? false:true} clickedAction={()=>{loadTag("poem")}} bText={"poem"} />
					</div>
				</div>			
			</div>
			</>)
			}
			
			{
				(toggleCreate) && (<div>
					<CreateBook updateData={()=>fetchFromParam()}/>
				</div>)
			}
			<div className={s.pagingHolder}>
				<ul>
					{pageData.pageOptions.map(p => (
							
						<li key={p} onClick={()=>updatePage(p)}  className={s.pagingPage}>
							{p}
						</li>
							
						))
					}
				</ul>
			</div>
			
			<DataList items = {generalData.items}/>
			
		</div>
  );
}